/* global $ */
/* global prestashop */
/* global warningCart */

const TCAISearch = {

    initalization: function () {
        this.removeHiddenSearchInput();
        this.search();
        this.clickSearch();
        this.clearInputSearchAction();
        this.fillSearchButtonLink();
        this.fillEnterSearchInput();
        this.detectChangeOrientation();
    },

    detectChangeOrientation: function () {
        window.addEventListener('resize', function () {
            const searchResults = document.getElementById('tcai-search-results');
            const searchInput = document.querySelector('.tcai_search-input');

            if (!searchResults || !searchInput) {
                return
            }

            const borderWidth = parseFloat(window.getComputedStyle(searchInput).borderTopWidth);
            searchResults.style.setProperty('top', searchInput.getBoundingClientRect().top + searchInput.getBoundingClientRect().height + window.scrollY + borderWidth + 'px');
        });
    },

    removeHiddenSearchInput: function () {
        const searchInputs = document.querySelectorAll('.tcai_search-input');

        searchInputs.forEach(searchInput => {
            if (searchInput.offsetParent === null) {
                searchInput.closest('.tcai_search').remove();
            }
        });
    },

    getTopSearchQuery: function () {
        const inputToken = document.getElementById('tcai_search_input_token');
        if (!inputToken) {
            return
        }

        return fetch('/module/tcai_presta_plugin/topquery?token=' + inputToken.value, {
            method: 'GET'
        }).then(response => response.json())
            .then(data => {
                return data;
            });
    },

    prefetchData: function (searchQuery) {
        const inputToken = document.getElementById('tcai_search_input_token');
        if (!inputToken) {
            return
        }

        const formData = new FormData();
        formData.append('search_query', searchQuery);
        formData.append('token', inputToken.value);

        fetch('/module/tcai_presta_plugin/prefetchdata', {
            method: 'POST', body: formData,
        }).then(response => response.json())
            .then(data => {
                if (data.success === true) {
                    const showAllResultsButton = document.querySelector('.show-all-results a');
                    if (!showAllResultsButton) {
                        return
                    }

                    showAllResultsButton.removeAttribute('style');
                }
            });
    },

    clickSearch: function () {
        const inputSearch = document.querySelector('.tcai_search-input');
        const inputToken = document.getElementById('tcai_search_input_token');

        if (!inputSearch || !inputToken) {
            return
        }

        inputSearch.addEventListener('click', function () {
            if (inputSearch.value.length === 0) {

                TCAISearch.getTopSearchQuery().then(function (result) {
                    if (result.success === true) {
                        const formData = new FormData();
                        formData.append('search_query', result.top_query);
                        formData.append('event', 'click');
                        formData.append('token', inputToken.value);

                        fetch('/module/tcai_presta_plugin/search', {
                            method: 'POST', body: formData,
                        }).then(response => response.json())
                            .then(data => {
                                if (data.success === true) {
                                    if (Object.prototype.hasOwnProperty.call(data, 'results') && Object.prototype.hasOwnProperty.call(result, 'top_query')) {
                                        TCAISearch.fillResults(data.results);
                                        TCAISearch.prefetchData(result.top_query);
                                    }
                                } else {
                                    TCAISearch.displayNotification(warningCart, data.message);
                                }
                            });
                    } else {
                        TCAISearch.displayNotification(warningCart, result.message);
                    }
                });
            } else {
                const formData = new FormData();
                formData.append('search_query', inputSearch.value);
                formData.append('event', 'keyup');
                formData.append('token', inputToken.value);

                fetch('/module/tcai_presta_plugin/search', {
                    method: 'POST', body: formData,
                }).then(response => response.json())
                    .then(data => {
                        if (data.success === true) {
                            if (Object.prototype.hasOwnProperty.call(data, 'results')) {
                                TCAISearch.fillResults(data.results);
                                TCAISearch.prefetchData(inputSearch.value);
                            }
                        } else {
                            TCAISearch.displayNotification(warningCart, data.message);
                        }
                    });
            }
        });
    },

    search: function () {
        const inputSearch = document.querySelector('.tcai_search-input');
        const inputToken = document.getElementById('tcai_search_input_token');

        if (!inputSearch || !inputToken) {
            return
        }

        let timeout = null;

        inputSearch.addEventListener('keyup', function () {

            const clearInputSearch = document.querySelector('.tcai_search-cancel');

            if (!clearInputSearch) {
                return
            }

            clearInputSearch.classList.add('tcai_search-cancel-show');

            clearTimeout(timeout);

            timeout = setTimeout(function () {

                const formData = new FormData();
                formData.append('search_query', inputSearch.value);
                formData.append('event', 'keyup');
                formData.append('token', inputToken.value);

                fetch('/module/tcai_presta_plugin/search', {
                    method: 'POST', body: formData,
                }).then(response => response.json())
                    .then(data => {
                        if (data.success === true) {
                            if (Object.prototype.hasOwnProperty.call(data, 'results')) {
                                TCAISearch.fillResults(data.results);
                                TCAISearch.prefetchData(inputSearch.value);
                            }
                        } else {
                            TCAISearch.displayNotification(warningCart, data.message);
                        }
                    });
            }, 500);
        });
    },

    addCloseSearch: function (element) {
        const searchResultsCloseButton = element.querySelector('.tcai_search_button_cancel');

        if (!searchResultsCloseButton) {
            return
        }

        searchResultsCloseButton.addEventListener('click', function () {
            element.classList.remove('tcai_search-results-open');
            element.classList.add('tcai_search-results');
        });
    },

    fillEnterSearchInput: function () {
        const inputSearch = document.querySelector('.tcai_search-input');
        const inputToken = document.getElementById('tcai_search_input_token');

        if (!inputSearch || !inputToken) {
            return
        }

        inputSearch.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {

                fetch('/module/tcai_presta_plugin/searchlink?search_query=' + inputSearch.value + '&token=' + inputToken.value, {
                    method: 'GET',
                }).then(response => response.json())
                    .then(data => {
                        if (data.success === true) {
                            if (Object.prototype.hasOwnProperty.call(data, 'link')) {
                                window.open(data.link, '_self');
                            }
                        } else {
                            TCAISearch.displayNotification(warningCart, data.message);
                        }
                    });
            }
        });
    },

    fillSearchButtonLink: function () {
        const searchButtonLink = document.querySelector('.search-button-href');
        const inputSearch = document.querySelector('.tcai_search-input');
        const inputToken = document.getElementById('tcai_search_input_token');

        if (!searchButtonLink && !inputSearch && !inputToken) {
            return
        }

        inputSearch.addEventListener('keyup', () => {

            fetch('/module/tcai_presta_plugin/searchlink?search_query=' + inputSearch.value + '&token=' + inputToken.value, {
                method: 'GET',
            }).then(response => response.json())
                .then(data => {
                    if (data.success === true) {
                        if (Object.prototype.hasOwnProperty.call(data, 'link')) {
                            searchButtonLink.href = data.link;
                        }
                    } else {
                        TCAISearch.displayNotification(warningCart, data.message);
                    }
                });
        });
    },

    fillResults: function (results) {
        const searchResults = document.getElementById('tcai-search-results');
        const searchInput = document.querySelector('.tcai_search-input');

        if (!searchResults || !searchInput) {
            return
        }

        document.body.append(searchResults);

        if (results.length > 0) {
            const borderWidth = parseFloat(window.getComputedStyle(searchInput).borderTopWidth);

            searchResults.classList.remove('tcai_search-results');
            searchResults.classList.add('tcai_search-results-open');
            searchResults.style.setProperty('top', searchInput.getBoundingClientRect().top + searchInput.getBoundingClientRect().height + window.scrollY + borderWidth + 'px');

            searchResults.innerHTML = results;

            TCAISearch.fillSuggest(searchResults.querySelectorAll('.suggest-link'));
            TCAISearch.linkToProduct(searchResults.querySelectorAll('.tcai_product:not(.tcai-add-to-cart)'));
            TCAISearch.addToCart(searchResults.querySelectorAll('.tcai-add-to-cart'));
            TCAISearch.addCloseSearch(searchResults);
        } else {
            searchResults.classList.remove('tcai_search-open');
            searchResults.classList.add('tcai_search-results');

            searchResults.innerHTML = '';

            const clearInputSearch = document.querySelector('.tcai_search-cancel');
            clearInputSearch.classList.remove('tcai_search-cancel-show');
        }
    },

    fillSuggest: function (element = document.querySelectorAll('.suggest-link')) {
        if (!element) {
            return
        }

        element.forEach((suggestLink) => {
            suggestLink.addEventListener('click', () => {
                const searchInput = document.querySelector('.tcai_search-input');

                if (!searchInput) {
                    return
                }

                searchInput.scrollIntoView({block: 'end', behavior: 'smooth'});
                searchInput.value = suggestLink.innerHTML;
                searchInput.dispatchEvent(new Event('keyup'));
            });
        });
    },

    linkToProduct: function (element) {
        if (!element) {
            return
        }

        element.forEach((link) => {
            link.addEventListener('click', function () {
                window.open(link.getAttribute('data-link'), '_blank');
            });
        });
    },

    addToCart: function (element) {
        if (!element) {
            return
        }

        element.forEach((productToCart) => {
            productToCart.addEventListener('click', function (event) {
                event.stopPropagation();

                const formData = new FormData();
                formData.append('id_product', productToCart.getAttribute('id-product'));
                formData.append('id_customization', '0');
                formData.append('qty', productToCart.getAttribute('minimum-quantity'));
                formData.append('action', 'update');
                formData.append('add', '1');
                formData.append('ajax', 'true');
                formData.append('token', productToCart.getAttribute('token'));

                fetch(prestashop.urls.pages.cart, {
                    method: 'POST', body: (new URLSearchParams(formData)).toString(), headers: {
                        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
                    }
                }).then(response => response.text())
                    .then(data => {
                        TCAISearch.updateCart(JSON.parse(data));
                    });
            });

            productToCart.addEventListener('mouseover', function () {
                const parentProductDiv = productToCart.closest('.tcai_product');
                if (!parentProductDiv) {
                    return;
                }

                parentProductDiv.classList.add('no-hover');
            });

            productToCart.addEventListener('mouseleave', function () {
                const parentProductDiv = productToCart.closest('.tcai_product');
                if (!parentProductDiv) {
                    return;
                }

                parentProductDiv.classList.remove('no-hover');
            });
        });
    },

    updateCart: function (dataCart) {

        if (Array.isArray(dataCart['errors'])) {
            TCAISearch.displayNotification(warningCart, dataCart['errors'][0]);
        } else {
            const formData = new FormData();
            formData.append('id_product', dataCart.id_product);
            formData.append('id_product_attribute', dataCart.id_product_attribute);
            formData.append('id_customization', dataCart.id_customization);
            formData.append('action', 'add-to-cart');

            fetch('/module/tdshoppingcart/ajax', {
                method: 'POST', body: (new URLSearchParams(formData)).toString(), headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
                }
            }).then(response => response.text())
                .then(data => {
                    let responseJSON = JSON.parse(data);

                    const modals = document.querySelectorAll('#blockcart-modal');
                    modals.forEach((modal) => {
                        modal.remove();
                    });

                    const results = JSON.parse(data);
                    document.body.insertAdjacentHTML('beforeend', results.modal);
                    $('#blockcart-modal').modal('show');

                    const cartDivs = document.querySelectorAll('.elementor-widget-shopping-cart');
                    const cartSideCart = document.getElementById('offcanvas_sidecart');

                    if (cartDivs[0]) {
                        const cartDivDesktop = cartDivs[0].querySelector('.elementor-widget-container');
                        cartDivDesktop.innerHTML = responseJSON.preview;
                    }

                    if (cartDivs[1]) {
                        const cartDivMobile = cartDivs[1].querySelector('.elementor-widget-container');
                        cartDivMobile.innerHTML = responseJSON.preview;
                    }

                    if (cartSideCart) {
                        cartSideCart.outerHTML = responseJSON.sidecart;
                    }
                });
        }
    },

    clearInputSearchAction: function () {
        const clearInputSearchButton = document.querySelector('.tcai_search-cancel');
        const searchInput = document.querySelector('.tcai_search-input');
        const searchResults = document.querySelector('.tcai_search-results');

        if (!clearInputSearchButton || !searchInput || !searchResults) {
            return
        }

        clearInputSearchButton.addEventListener('click', function () {
            searchInput.value = null;
            searchResults.classList.add('tcai_search-results');
            searchResults.classList.remove('tcai_search-results-open');
            clearInputSearchButton.classList.add('tcai_search-cancel');
            clearInputSearchButton.classList.remove('tcai_search-cancel-show');
        });
    },

    displayNotification: function (title, message) {
        if (typeof $.growl !== 'undefined') {
            $.growl.warning({
                title: title, message: message,
            });

            $('.growl').css('opacity', '1');
            setTimeout(() => {
                $('.growl').css('opacity', '');
            }, 3200);
        }
    },
};

export default TCAISearch;